import { IAutomationObject } from '../../types'

export interface IFG_SAUTER_CoolingSetpoint extends IAutomationObject {
    flowBase: number;
    flowMin: number;
    outTBase: number;
    outTMax: number;
    reduceSetpoint: number;
    minOutTCooling: number;
    actSetpoint: number;

    onValueChanged: any;
}
export type  IFG_SAUTER_Line = {
    lines: 
        {
            name: string,
            points:  IFG_SAUTER_Point[],
            key: any
        }[]
}
export type  IFG_SAUTER_Point = {
    x: number,
    y: number
}
 
 
export const schema = 'AutomationApps.FunctionGroups.CoolingSetpoints.FG_SAUTER_CoolingSetpoint';


